export enum Language {
  ENGLISH = 'en',
  DANISH = 'da',
  GERMAN = 'de',
}
